/**
 * @file customer-chat.ts
 * @description Куда ведёт «Написать» в карточке клиента (phase19.31, SC64,
 * SC68) — одно место на шапку, блок «Связь» и строку «непрочитанное
 * сообщение».
 *
 * «Написать» открывает окно «Сообщения» поверх карточки, не уводя со
 * страницы: ссылка остаётся на этой же странице с параметрами окна
 * (`?chat=<диалог>&chatCustomer=<клиент>`), окно открывается и параметры
 * убирает (`useChatUrlParam`). Известен диалог — сразу он; нет — отбор
 * «Клиент: … ×» и самый свежий диалог, а без диалогов — новый «Общий чат».
 */

import { chatSearch } from "../../chat/useChatUrlParam";

export function customerChatHref(_slug: string | undefined, conversationId?: string, customerId?: string): string {
  return chatSearch({ conversationId, customerId });
}
